// extracted by mini-css-extract-plugin
module.exports = {"button":"activityLink_button__1t0gs","spanWrap":"activityLink_spanWrap__B-dH8"};